/* eslint-disable react/display-name */
import React from "react";
import classNames from "classnames";
import styles from "./index.module.css";

interface CheckboxProps {
  label?: string;
  checked: boolean;
  onChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  id?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { label, checked, onChange, disabled, className, labelClassName, id },
    ref
  ) => {
    return (
      <label
        className={classNames(styles.checkbox, className, {
          [styles.checkboxDisabled]: disabled,
        })}
        id={id}
        data-testid={id}
      >
        <input
          ref={ref}
          type="checkbox"
          className="flex-shrink-0 mr-2 size-4"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div className="absolute">
          <svg width="16" height="16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M13.333 4L6 11.333 2.667 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" id="checkboxpath" />
          </svg>
        </div>
        {!!label && <span className={labelClassName}>{label}</span>}
      </label>
    );
  }
);
